<template>
  <transition
    :enter-active-class="transitionEnterClass"
    :leave-active-class="transitionLeaveClass"
    name="slide"
    mode="out-in"
  >
    <keep-alive include="EmployeesTable">
      <v-container
        grid-list-md
        class="pa-2"
        fluid
      >
        <router-view :key="$route.path" />
      </v-container>
    </keep-alive>
  </transition>
</template>

<script>
import pageTransitionMixin from '@/mixins/page-transition-mixin';

export default {
  name: 'Employees',
  mixins: [pageTransitionMixin],
  data() {
    return {};
  },
  beforeRouteUpdate(to, from, next) {
    this.updatePageTransition(to, from);
    next();
  },
  created() {
    this.$store.commit('setToolbarTitle', { toolbarTitle: 'Employees' });
  }
};
</script>
